import React, { useState} from "react";
import DupontCheckbox from "components/DupontCheckbox";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles(theme => ({
  checkboxContainer: { display: "block", marginTop: "10px" }
}));

const NotificationCheckboxRenderer = props => {
  const classes = useStyles();
  const { field } = props;
  const [isChecked, setIsChecked] = useState(props.node.data[field]);

  const selectionChangeHandler = val => {
    const data = props.node.data;
    const { SystemName: SystemId, ReceiverId } = data;
    props.node.setData({ ...data, [field]: val });
    props.context.onUpdateAlerts({ SystemId, ReceiverId, [field]: val });
  };

  return (
    <span className={classes.checkboxContainer}>
      <DupontCheckbox checked={isChecked} onChange={selectionChangeHandler} />
    </span>
  );
};

export default NotificationCheckboxRenderer;
